import { CategoryRepository } from "../../../../data/repository/category/CategoryRepository";
import { StoreRepository } from "../../../../data/repository/store/StoreRepository";
import { Category } from "../../../model/Category";
import { ResponseState, State } from "../../../model/ResponseState";
import { Store } from "../../../model/Store";

export interface GetAllStoresUseCase {
  invoke: () => Promise<ResponseState<Array<Store>>>;
}

export class GetAllStoresUseCaseImpl implements GetAllStoresUseCase {
  private repo: StoreRepository;

  constructor(repo: StoreRepository) {
    this.repo = repo;
  }

  async invoke(): Promise<ResponseState<Array<Store>>> {
    try {
      let response = await this.repo.getStores();
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
